import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'

const routes = [
  {
    path: '/work_order_finance',
    name: 'work_order_finance',
    meta: { title: '财务' },
    redirect: '/work_order_finance/overview',
    component: Main,
    children: [
      {
        path: '/work_order_finance',
        name: 'work_order_finance_group',
        meta: {
          title: '工单财务',
          parentPath: '/work_order_finance',
          icon: 'icon_caiwu_yue'
        },
        redirect: '/work_order_finance/overview',
        component: Blank,
        children: [
          {
            path: '/work_order_finance/overview',
            name: 'work_order_finance_overview',
            meta: {
              title: '财务概览',
              parentPath: '/work_order_finance',
              icon: 'icon_caiwu_yue',
              keepAlive: true
            },
            component: () => import('@/views/work_order_finance/overview.vue')
          },
          {
            path: '/work_order_finance/daily',
            name: 'work_order_finance_daily',
            meta: {
              title: '日报明细',
              parentPath: '/work_order_finance',
              icon: 'icon_caiwu_yue',
              keepAlive: true
            },
            component: () => import('@/views/work_order_finance/daily.vue')
          }
        ]
      }
    ]
  }
]

export default routes
